import { ConversationParticipant } from '@centecomm/portal-service';
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { conversationsSelectors } from 'State';
import { ParticipantWasRemovedFromConversation as ParticipantRemovedEvent } from 'Types/Conversations/Events';
import styles from '../conversations.module.css';

interface ParticipantWasRemovedFromConversationProps {
    conversationId: number;
    event: ParticipantRemovedEvent;
}

function ParticipantWasRemovedFromConversation({
    conversationId,
    event,
}: ParticipantWasRemovedFromConversationProps): React.ReactElement<ParticipantWasRemovedFromConversationProps> {
    useTranslation(['conversationsFeature']);
    const { removedUserId, metadata } = event;

    const { userId: removerUserId } = metadata;

    const removedParticipant: ConversationParticipant | undefined = useSelector(
        conversationsSelectors.conversationParticipant(conversationId, removedUserId),
    );

    const removingParticipant: ConversationParticipant | undefined = useSelector(
        conversationsSelectors.conversationParticipant(conversationId, removerUserId),
    );

    const resolvedI18nKey = useMemo(() => {
        if (removedParticipant && removingParticipant) {
            return 'conversationsFeature:events.participantWasRemovedFromConversation.usernameRemovedUsername';
        }

        if (removingParticipant && !removedParticipant) {
            return 'conversationsFeature:events.participantWasRemovedFromConversation.usernameRemovedUnknown';
        }

        if (!removingParticipant && removedParticipant) {
            return 'conversationsFeature:events.participantWasRemovedFromConversation.unknownRemovedUsername';
        }

        return 'conversationsFeature:events.participantWasRemovedFromConversation.unknownRemovedUnknown';
    }, [removedParticipant, removingParticipant]);

    return (
        <div className={styles.SystemItem}>
            <p>
                <Trans
                    i18nKey={resolvedI18nKey}
                    components={{
                        span: <span />,
                    }}
                    values={{
                        username: removedParticipant?.userName,
                        removingUsername: removingParticipant?.userName,
                    }}
                />
            </p>
        </div>
    );
}

export default ParticipantWasRemovedFromConversation;
